import React from "react";

import Table from "../../../common/Table";

import { Link } from "react-router-dom";

const DataTable = ({ data, query }) => {
  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/students/${e.student_id}/profile/fees?stdName=${e.student_name}`}
      >
        {e.student_name}
      </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "student_name",
      label: "نام",
      content: (e) => renderLink(e),
    },
    { path: "class_desc", label: "صنف" },
    { path: "issue_date", label: "تاریخ صدور" },
    { path: "valid_from_entry_year", label: "از" },
    { path: "valid_until_entry_year", label: "تا" },
    { path: "amount", label: "مبلغ" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default DataTable;
